// cleanup_convert_to_typescript_file_USER_EMULATION

import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: { background, grey, secondary, text },
  spacing: { unit },
  typography: { fontWeightRegular, headline2, title }
}) => ({
  root: {
    background,
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%'
  },
  error: {
    '&.alert .alert__content': {
      width: `calc(100% - 80px)`
    }
  },
  alertChild: {
    margin: 'auto'
  },
  alert: {
    borderRadius: 0,
    boxShadow: 'none',
    left: '50%',
    marginBottom: 0,
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    width: '100vw',
    height: '100vh',
    border: `1px solid ${grey.G200}`,

    '&.alert': {
      borderLeftColor: grey.G200
    },

    '& .alert__content': {
      position: 'relative',
      width: '100%'
    },

    '&.alert $h4': {
      fontWeight: fontWeightRegular,
      marginTop: 3 * unit
    }
  },
  emulationAlert: {
    margin: [0, 'auto', 3 * unit],
    width: 'fit-content'
  },
  preventOverflow: {
    display: 'flex',
    alignItems: 'center'
  },
  form: {
    margin: `${4.375 * unit}px auto 0`,
    maxWidth: 440,
    padding: [0, 3 * unit]
  },
  fieldset: {
    marginBottom: 0,
    '& .flex-dropdown-root': {
      '&.disabled .selection, & .selection.disabled': {
        background: 'none',
        borderColor: grey.G400,
        opacity: 0.4
      },
      '&.disabled label': {
        opacity: 0.4
      }
    },
    '& .flex-dropdown-wrapper .flex-dropdown .list, & .flex-dropdown': {
      width: '100%'
    },

    '& .form-group': {
      margin: 0
    },

    '& .margins.form-group': {
      marginBottom: 3.75 * unit
    }
  },
  buttons: {
    display: 'flex',
    margin: `${5 * unit}px 0 0`,
    paddingBottom: 3 * unit,
    '& .tertiary': {
      marginLeft: 3.75 * unit
    }
  },
  h2: {
    ...headline2,
    margin: `${2.625 * unit}px 0 0`,
    textAlign: 'center'
  },
  h4: {
    ...title,
    textAlign: 'center'
  },
  magnify: {
    '& svg': {
      fill: text.dark
    }
  },
  xcircle: {
    cursor: 'pointer',
    position: 'absolute',
    right: 0,

    '& svg': {
      fill: text.dark
    }
  },
  spinner: {
    '& [role=progressbar]': {
      margin: `${4 * unit}px auto ${2 * unit}px`
    }
  },
  icon: {
    display: 'flex',
    '& svg': {
      fill: secondary.normal,
      height: 50,
      margin: '0 auto',
      width: 50
    }
  },
  dropDown: {
    marginBottom: '25px !important',
    '& [data-qa="dropdown-position"]': {
      zIndex: 10,
      backgroundColor: background
    }
  }
});

export default createUseStyles(styles);
